<div #rcWrapper class="remote-control-wrapper">
  <app-remote-control [workItem]="workItem"></app-remote-control>
  <app-chat-viewer [@chatAnimation]="isChatMinimized ? 'minimized' : 'expanded'"
                   (@chatAnimation.start)="onAnimationStart($event)"
                   [ngClass]="{ 'minimized': isChatMinimized }"
                   *ngIf="canShowChatInRC && isRCFullScreen()"
                   [hasFullScreenRc]="true"
                   (closeAction)="toggleChatMinimized()"
                   [showActivityIndicator]="isChatMinimized"
                   [chatId]="workItem.id"
                   [draggable]="true"
                   [dragBoundaryElementSelector]="'.remote-control-wrapper'"></app-chat-viewer>
</div>
